module.exports = __webpack_public_path__ + "img/product_4.61d90e35.png";